/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IUnlockModalScope extends ng.IScope {
        name: string;
        block: Models.IBlock;
        timezoneService: Services.TimezoneService;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * ConfirmModalController class
     */
    export class UnlockModalController {
        public static templateURL: string = "decorators/modals/unlock-modal.html";
        public static ID: string = "#id-unlock-modal";
        public static $name: string = "unlockModalController";
        public static $inject: string[] = ['$scope', 'timezoneService', 'close', 'block'];

        private $scope: IUnlockModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IUnlockModalScope,
                    timezoneService: Services.TimezoneService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    block: Models.IBlock) {
            this.$scope = $scope;
            this.$scope.timezoneService = timezoneService;
            this.close = close;
            this.$scope.block = block;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                this.close("OK");
            };
        }
    }
}
